export const APPS = "APPS";
export const CONTACT_FORM = "CONTACT_FORM";
export const AUTH = "AUTH";
export const SURVEY = "SURVEY";
export const MODULE = "MODULE";
export const COMPANY = "COMPANY";
export const SERVICE_CENTERS = "SERVICE_CENTERS";
export const SERVICE_TYPES = "SERVICE_TYPES";
export const SERVICE_MEN = "SERVICE_MEN";
export const OFFDAYS = "OFFDAYS";
export const SERVICES = "SERVICES";
export const SUBSCRIPTION = "SUBSCRIPTION";
export const QUESTION = "QUESTION";
export const REPORT = "REPORT";
export const USER = "USER";
export const ROLE = "ROLE";
export const USERS = "USERS";
export const ACCOUNTS = "ACCOUNTS";
export const VOUCHERS = "VOUCHERS";
export const LEDGER_TYPES = "LEDGER_TYPES";
export const CUSTOM_FIELDS = "CUSTOM_FIELDS";
export const BUSINESS_TYPES = "BUSINESS_TYPES";
export const TAGS = "TAGS";
export const LOCATIONS = "LOCATIONS";
export const ME = "ME";
export const LOCATION = "LOCATION";
export const SETTINGS = "SETTINGS";
export const COUNTRIES = "COUNTRIES";
export const LANGUAGES = "LANGUAGES";
export const SUBMISSIONS = "SUBMISSIONS";
export const NOTIFICATION = "NOTIFICATION";
export const DATASOURCES = "DATASOURCES";
export const DATASOURCE = "DATASOURCE";
export const STATS = "STATS";
export const TRANSLATION = "TRANSLATION";
export const APPLICATION_TYPE = "APPLICATION_TYPE";
export const APPLICATION_TYPE_FIELD = "APPLICATION_TYPE_FIELD";
export const APPLICATION = "APPLICATION";
export const APPLICATION_SUBMISSION = "APPLICATION_SUBMISSION";